import { render, staticRenderFns } from "./NotificationWrapper.vue?vue&type=template&id=52b8e2e8&scoped=true&lang=pug&"
import script from "./NotificationWrapper.vue?vue&type=script&lang=ts&"
export * from "./NotificationWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationWrapper.vue?vue&type=style&index=0&id=52b8e2e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b8e2e8",
  null
  
)

export default component.exports